<template>
  <page>
    <module enable-flex ref="view">
      <m-search ref="search" @search="searchHandle">
        <c-form ref="searchForm">
          <c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
                       type="select" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
          <c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
          <c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly
                       @click="$refs.stationedSelector.open()"></c-form-item>
          <c-form-item type="input" label="订单号" name="order_number"></c-form-item>
          <c-form-item type="input" label="买家" name="user_info" placeholder="买家昵称、手机号"></c-form-item>
          <c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
          <c-form-item type="input" label="商品规格" name="product_sku_spec" placeholder="模糊匹配"></c-form-item>
          <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="精确匹配"></c-form-item>
          <c-form-item type="input" label="收货信息" name="receiving_info" placeholder="收货人、电话、地址"></c-form-item>
          <c-form-item type="input" label="运单号" name="logistics_number" placeholder="模糊匹配"></c-form-item>
          <c-form-item type="datetime" label="终端下单时间" start-name="start_date" end-name="end_date"></c-form-item>
          <c-form-item type="datetime" label="终端付款时间" start-name="pay_start_date" end-name="pay_end_date"></c-form-item>
          <c-form-item type="datetime" label="发货时间" start-name="send_start_date" end-name="send_end_date"></c-form-item>
          <c-form-item type="checkbox" label="" name="order_type" :options="orderType"></c-form-item>
          <c-form-item v-if="systemConfig.is_virtual_product == 'ON'" type="checkbox" label="" name="order_classify" :options="orderClassify"></c-form-item>
          <c-form-item type="checkbox" v-if="systemConfig.order_check_enabled == 'ON' || systemConfig.cash_pay == 'ON'"
                       label="审核状态" name="check_state" :options="checkState"></c-form-item>
          <c-form-item type="checkbox" label="" name="order_state" :options="orderState"></c-form-item>
          <c-form-item v-if="systemConfig.order_invoice_enabled == 'ON'" type="checkbox" label=""
                       name="is_cloud_stock" :options="cloudStock"></c-form-item>
          <c-form-item v-if="systemConfig.order_invoice_enabled == 'ON'" type="checkbox" label=""
                       name="invoice_state" :options="invoiceState"></c-form-item>
          <c-form-item v-if="systemConfig.order_push_enabled == 'ON'" type="checkbox" label="推送状态" name="push_state"
                       :options="pushState"></c-form-item>
        </c-form>
      </m-search>
      <m-operate>
        <c-button power="b_retail_order_deliver" @click="$refs.excelImport.open()" icon="upload" color="black">导入发货</c-button>
<!--        <c-button power="b_retail_order_export" @click="exportData()" icon="export">导出订单明细</c-button>-->
        <c-button power="b_retail_order_invoice_finish" v-if="systemConfig.order_invoice_enabled == 'ON'" @click="batchInvoiceFinish()">批量开票完成</c-button>
        <c-button color="m" hollow @click="syncExport()">导出订单明细</c-button>

        <template #right>
          <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列
          </c-button>
        </template>
      </m-operate>
      <c-table ref="table">
        <c-table-column width="400">
          <template slot="head">
            <span style="margin-left: 15px;">商品信息</span>
          </template>
        </c-table-column>

        <c-table-column
            label="单价"
            width="130"
            align-center
        ></c-table-column>

        <c-table-column
            label="数量"
            width="130"
            align-center
        ></c-table-column>

        <c-table-column
            label="总金额"
            width="170"
            align-center
        ></c-table-column>

        <c-table-column
            label="交易状态"
            width="170"
            align-center
        ></c-table-column>

        <c-table-column
            label="操作"
            width="170"
            align-center
        ></c-table-column>

        <template #custom="{data}">
          <div :key="data.id" class="order">
            <div class="order-head flex-between-center">
              <div class="flex-center">
                <input  type="checkbox" :value="data.order_number" v-model="data.checked"/>
                <span class="number">
                     订单号：
                    <a style="color:blue;" @click="navigateTo(`/order_detail/${data.order_number}`)">
                        {{data.order_number}}
                    </a>
                </span>
                <div class="tag" v-if="data.order_classify == 1 && systemConfig.is_virtual_product == 'ON'"
                     style="background: #00B2FB">实物
                </div>
                <div class="tag" v-if="data.order_classify == 2 && systemConfig.is_virtual_product == 'ON'"
                     style="background: #FFDE00">虚拟
                </div>
                <div class="tag" v-if="data.is_cloud_stock == 1 && systemConfig.cloud_stock == 'ON'"
                     style="background: #057215">囤货
                </div>
                <div class="tag" v-if="data.order_type!=1" style="background: #4686e0">
                      {{ orderTypeName[data.order_type] }}
                </div>
                <p class="info" v-if="systemConfig.pt_mode == 2">
                  归属商家：{{ data.stationed_name }}
                </p>
                <p class="info">
                  终端下单时间：{{ data.create_date }}
                </p>
                <p class="info" v-if="data.payment_state == 3 && data.payment_date">
                  终端支付时间：{{ data.payment_date }}
                </p>
              </div>
            </div>
            <div class="order-head flex-between-center">
              <div class="flex-center">
                <span class="number">
                  商户订单号： {{data.out_trade_no||'--'}}
                </span>
                <p class="info">
                  三方支付号：{{data.third_number||'--'}}
                </p>
                <p class="info">
                  转单至平台时间：{{ data.transfer_to_platform_date }}
                </p>
                <p class="info" v-if="data.last_send_date">
                  最近发货时间：{{ data.last_send_date }}
                </p>
              </div>
            </div>
            <div class="order-head flex">
              <span
                  class="number">买家：{{ data.nick_name || data.receiving_name }}（{{ data.user_manage_mobilephone }}）</span>
              <p class="info"
                 v-if="data.order_classify == 1 && data.receiving_name && data.receiving_phone && data.receiving_address">
                收货信息：{{ data.receiving_name }}；{{ data.receiving_phone }}；{{ data.receiving_address }}
                <a power="b_retail_order_deliver"
                   v-if="data.operation_mode != 2 && systemConfig.order_invoice_enabled == 'ON' &&  data.refund_flag != 1 && data.return_flag!=1 && (data.order_state == 1 || data.order_state == 2)"
                   style="margin-left: 5px;color:blue" @click="$refs.orderAddressEdit.open(data.order_number)">修改</a>
              </p>
              <div class="info flex flex-grow"
                   v-if="data.order_classify == 1 && data.send_logistics_number_list && data.send_logistics_number_list.length > 0">
                <p>发货物流：</p>
                <div class="flex-grow flex-wrap">
                  <template v-for="(item, i) in data.send_logistics_number_list">
                    <p :key="i" style="max-width: 100%; word-break: break-all; white-space: normal;">
                      <span>{{ item.logistics_company }}</span>
                      <span v-if="item.logistics_number">({{ item.logistics_number || '--' }})</span>
                      <a style="margin-left: 5px;color:blue;" power="b_retail_order_deliver" v-if="data.order_state == 3" @click="editLogisticsCompany(item)">修改</a>
                      <span>；</span>
                    </p>
                  </template>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="order-product">
                <div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
                  <div class="sku-info flex-center flex-grow">
                    <c-image class="sku-image" :src="sku.product_img_url"></c-image>
                    <div class="flex-grow">
                      <p class="sku-name ellipsis">{{ sku.product_name }}</p>
                      <p class="sku-sku">
                        <a style="color:darkgray" v-if="sku.product_sku_spec">规格：</a>{{ sku.product_sku_spec }}；
                        <a style="color:darkgray" v-if="sku.product_sku_code">SKU编码：</a>{{ sku.product_sku_code }}
                      </p>
                    </div>
                  </div>
                  <div class="sku-price">￥{{ sku.product_unit_price }}</div>
                  <div class="sku-count">{{ sku.product_count }}</div>
                </div>
              </div>
              <div class="order-sum flex-column flex-center">
								<span v-if="data.order_type==2">
									{{ data.points }}积分
                                    <span v-if="data.product_money && data.product_money > 0">
                                        + ￥{{ parseFloat(data.product_money).toFixed(2) }}
                                    </span>
								</span>
                <span v-if="data.order_type==2 && data.logistics_money > 0">
									(另运费￥{{ parseFloat(data.logistics_money).toFixed(2) }})
								</span>
                <span v-if="data.order_type!=2 && data.payment_state != 3">
									￥{{ parseFloat(data.product_money + data.custom_money + data.logistics_money + data.total_fee_money).toFixed(2) }}
								</span>
                <span v-if="data.order_type!=2 && data.payment_state == 3">
									￥{{ parseFloat(data.payment_money).toFixed(2) }}
								</span>
                <span v-if="data.order_type!=2 && data.logistics_money > 0">
									(含运费￥{{ parseFloat(data.logistics_money).toFixed(2) }})
								</span>
                <span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
									(含服务费￥{{ parseFloat(data.total_fee_money).toFixed(2) }})
								</span>
                <span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
									(含定制费￥{{ parseFloat(data.custom_money).toFixed(2) }})
								</span>
              </div>
              <div class="order-state flex-column flex-center">
                <span v-if="data.check_state==1 && data.payment_type=='转账支付'" style="color:#182eff">待审核</span>
                <span v-else>
                        <span v-if="data.order_state == 2 && data.order_type == 10 && data.receive_state == 0" style="color:#bd2c00">
                            待收礼
                        </span>
                        <span v-else-if="data.order_type == 8 && data.group_achieve == 0" style="color:#bd2c00">
                           待成团
                        </span>
                        <span v-else>
                            <span v-if="data.order_state!= 6 && data.order_classify == 2 && data.order_state == 3">待使用</span>
                            <span v-else-if="data.order_state!= 6 && data.order_type == 6 && data.payment_state == 1">待付定金</span>
                            <span v-else-if="data.order_state!= 6 && data.order_type == 6 && data.payment_state == 2">待付尾款</span>
                            <span v-else>{{ orderStateName[data.order_state] }}</span>
                            <span v-if="data.return_flag==1">(售后中)</span>
                            <span v-else-if="data.refund_flag==1">(未发退款中)</span>
                        </span>
				</span>
                <span v-if="data.order_state == 3">({{ data.deliver_state }})</span>
                <a @click="navigateTo(`/retail_order/${data.order_number}`)">订单详情</a>
              </div>
              <div class="order-handle flex-column flex-center">
                <c-button color="gray" hollow
                          v-if="data.operation_mode != 2 && data.check_state==1 && data.order_state != 6"
                          @click="navigateTo(`/retail_order/${data.order_number}`)">审批
                </c-button>
                <c-button color="gray" hollow power="b_retail_order_deliver"
                          v-if="data.check_state==2
                          &&(data.order_type != 10 ||(data.order_type == 10 && data.receive_state == 1))
                          && data.is_cloud_stock == 0
                          && ((data.order_type == 8 && data.group_achieve == 1)||(data.order_type != 8))
                          && data.operation_mode != 2 && data.refund_flag==0 && data.return_flag==0 && data.check_state == 2
                          && (data.order_state == 2 || (data.order_state == 3 && data.deliver_state =='部分发货'))
                          && data.is_cloud_stock != 1"
                          @click="$refs.orderProductSend.open(data.order_number)">发货
                </c-button>
                <c-button color="gray" hollow power="b_retail_order_refund_apply"
                          v-if="data.check_state==2
                          && (data.order_type != 2 && data.order_type != 3 && data.order_type != 9 && data.order_type != 11)
                          && data.check_state == 2 && data.refund_flag!=1 && data.return_flag!=1
                          && (data.order_state==2 || data.order_state==3 || data.order_state==5)
                          && data.is_cloud_stock != 1"
                          @click="navigateTo(`/after_sales_apply?orderNumber=${data.order_number}`)">申请售后
                </c-button>
                <c-button color="gray" hollow power="b_retail_order_close"
                          v-if="data.check_state==2
                          && data.refund_flag != 1 && data.return_flag!=1
                          && (data.order_state == 1 || data.order_state == 2)
                          && data.is_cloud_stock != 1
                          && (data.payment_state == 1 || (
                              data.order_state == 2 && data.order_type != 2 && data.order_type != 3 && data.order_type != 11
                          ))"
                          @click="closeHandle(false,data)">关闭
                </c-button>
                <c-button color="gray" hollow
                          v-if="data.check_state==2
                          && data.operation_mode != 2 && data.check_state == 2
                          && data.refund_flag!=1 && data.return_flag!=1
                          && data.invoice_state == 1 && data.invoice_count > 0
                          && (data.order_state == 3 || data.order_state == 5)"
                          power="b_retail_order_invoice_finish" @click="onInvoiceFinish(data)">开票完成
                </c-button>
              </div>
            </div>
          </div>
        </template>
      </c-table>
    </module>
    <!-- 关闭订单弹框 -->
    <c-dialog ref="closeDia" :title="'取消订单-'+orderNumber" width="600" @resolve="closeHandle">
      <div class="order-verify">
        <textarea v-model="cancel_reason" placeholder="请输入取消原因..."></textarea>
      </div>
    </c-dialog>
    <!--开票完成弹框 -->
    <c-dialog ref="invoiceConf" title="开票确认" button-name="确认开票完成" width="550" height="360"
              @resolve="submitInvoiceFinish">
      <c-form ref="invoiceConfForm">
        <div class="invoice">
          <p v-html="text_msg"></p>
          <c-form-item type="datetime" v-model="invoiceDate" label="开票时间"></c-form-item>
          <c-form-item type="number" v-if="is_bath == 0" v-model="realityMoney" :limit="9999999" decimal="2" label="实收金额"></c-form-item>
          <p v-if="is_bath == 1" style="color:red">批量开票时,默认实收金额与订单支付金额一致</p>
          <c-form-item type="radio" label="开票凭证" name="invoice_file_type"
                       v-model="invoice_file_type" :options="invoiceFileType"></c-form-item>
          <c-form-item type="file" v-if="invoice_file_type == 1" label="附件" v-model="invoice_file"
                       name="invoice_file" file-type="image,pdf"></c-form-item>
          <c-form-item type="input" v-if="invoice_file_type == 2" label="链接" v-model="invoice_file"
                       word="http://或https://开头" name="invoice_file"></c-form-item>
        </div>
      </c-form>
    </c-dialog>

    <!--修改配送方式 -->
    <c-dialog ref="editLogisticsCompanyDia" title="修改发货物流" width="700" @resolve="editLogisticsCompanyHandle">
      <c-form ref="editLogisticsCompanyForm">
        <c-form-item type="hidden" name="id"></c-form-item>
        <c-form-item type="input" label="订单号" name="order_number" :disabled="true"></c-form-item>
        <c-form-item type="input" label="装箱箱码" name="pack_number" :disabled="true"></c-form-item>
        <c-form-item type="input" label="发货时间" name="send_date" :disabled="true"></c-form-item>
        <c-form-item type="select" label="发货物流：" :options="logisticsCompany" name="logistics_id" required></c-form-item>
        <c-form-item type="input" label="运单号码：" name="logistics_number" required></c-form-item>
      </c-form>
    </c-dialog>

    <stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
    <order-address-edit ref="orderAddressEdit" @resolve="$refs.table.update();"></order-address-edit>
    <order-product-send ref="orderProductSend" @resolve="$refs.table.update();"></order-product-send>
    <excel-import ref="excelImport" :work-type="importWorkType" @resolve="$refs.table.update();"></excel-import>
  </page>
</template>

<script>
import {mapState} from 'vuex'
import productInfo from '@/components/public/product_info.vue'
import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
import orderAddressEdit from '@/components/service/order_address_edit.vue'  // 编辑订单收货地址
import orderProductSend from '@/components/service/order_product_send.vue'  // 订单发货
import excelImport from "@/components/service/import_excel_data.vue";  // 导入数据

export default {
  name: 'm_retail_order',

  // 第二步：定义组件，导入了哪些就定义哪些
  components: {
      stationedSelector,
      productInfo,
      orderAddressEdit,
      orderProductSend,
      excelImport
  },

  props: {
    check_state: String,
    order_state: String,
    invoice_state: String,
    pay_state: String,
    reconciliation_state: String
  },

  data() {
    return {
      importWorkType: 901,
      workType: 14,
      searchParams: {},
      is_bath: 0,
      text_msg: '',
      realityMoney: 0,
      invoiceDate: '',	//开票时间
      cancel_reason: '', //关闭原因
      invoice_file_type: '',//开票文件类型
      invoice_file: '',//发票文件
      logistics_company_name: '',
      self_pick: false,//1=自提
      logisticsCompany: [],
      orderDetail: {},
      orderNumber: '',
      sendList: [],
      sendNum: {},
      orderStateName: {
        1: '待付款',
        2: '待发货',
        3: '待收货',
        5: '交易完结',
        6: '已关闭'
      },
      operationModeName: {
        1: '平台自营',
        2: '商家自营'
      },
      orderTypeName: {
        1: '普通',
        2: '积分',
        3: '升级赠品',
        4: '砍价',
        5: '预售订单(全款)',
        6: '预售订单(定金)',
        7: '定制',
        8: '拼团',
        9: '云仓提货',
        10: '送礼',
        11: '抽奖'
      },
      orderClassifyName: {
        1: '实物',
        2: '虚拟',
      },
      orderSourceName: {
        'OMS': '管理后台',
        'IOS': '苹果',
        'ANDROID': '安卓',
        'MINI': '小程序',
        'PC': 'PC电脑'
      },
      freightPaymentTypeName: {
        1: '运费先付',
        2: '运费到付'
      },
      orderState: [
        {name: '待付款', value: 1},
        {name: '待发货', value: 2},
        {name: '待收货', value: 3},
        {name: '交易完结', value: 5},
        {name: '已关闭', value: 6}
      ],
      checkState: [
        {name: '待审核', value: 1},
        {name: '审核通过', value: 2},
        {name: '审核驳回', value: 3}
      ],
      invoiceStateName: {
        0: '无需开票',
        1: '未开票',
        2: '已开票'
      },
      pushState: [
        {name: '无需推送', value: 0},
        {name: '待推送', value: 1},
        {name: '已推送', value: 2}
      ],
      operationMode: [
        {name: '平台自营', value: 1},
        {name: '商家自营', value: 2}
      ],
      cloudStock: [
        {name: '非囤货', value: 0},
        {name: '囤货', value: 1}
      ],
      invoiceState: [
        {name: '无需开票', value: 0},
        {name: '未开票', value: 1},
        {name: '已开票', value: 2}
      ],
      invoiceFileType: [
        {name: '附件', value: 1},
        {name: '链接', value: 2}
      ],
      orderClassify: [
        {name: '实物', value: 1},
        {name: '虚拟', value: 2}
      ],
      sendCompanyList: [],
      companyIdIndex: 1
    }
  },

  computed: {
    ...mapState(['systemConfig', 'userInfo']),
    orderType() {
      return (
              [{
                name: '普通',
                value: 1
              }, {
                name: '送礼',
                value: 10
              }].concat(this.systemConfig.points_system == 'ON' ? [{
                name: '积分',
                value: 2
              }] : [])
              .concat(this.systemConfig.bargain_enabled == 'ON' ? [{
                name: '砍价',
                value: 4
              }] : [])
              .concat(this.systemConfig.presell_enabled == 'ON' ? [{
                name: '预售订单(全款)',
                value: 5
              }] : [])
              .concat(this.systemConfig.presell_enabled == 'ON' ? [{
                name: '预售订单(定金)',
                value: 6
              }] : [])
              .concat(this.systemConfig.product_custom == 'ON' ? [{
                name: '定制',
                value: 7
              }] : [])
              .concat([{
                name: '拼团',
                value: 8
              }])
              .concat(this.systemConfig.cloud_stock == 'ON' ? [{
                name: '云仓提货',
                value: 9
              }] : [])
              .concat([{
                  name: '抽奖',
                  value: 11
              }])
      );
    },
    defaultSearch() {
      let param = {
        check_state: this.check_state ? this.check_state.split(',') : [],
        order_state: this.order_state ? this.order_state.split(',') : [],
        invoice_state: this.invoice_state ? this.invoice_state.split(',') : [],
        reconciliation_state: this.reconciliation_state ? this.reconciliation_state.split(',') : [],
      }

      if (this.pay_state == 1) {
        param.pay_start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
        param.pay_end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
      }

      return param;
    }
  },

  watch: {
    defaultSearch(val) {
      this.$refs.searchForm.set(val);
      this.$nextTick(() => {
        this.$refs.search.search();
      })
    }
  },

  mounted() {
    this.$refs.searchForm.set(this.defaultSearch);
    this.$nextTick(() => {
      this.$refs.search.search();
    })
    this.$bus.$on('order.update', data => {
      // 刷新列表
      this.$refs.table.update();
    });
    //初始化加载【发货物流】列表
    this.initLogisticsCompany();
  },


  methods: {
    initLogisticsCompany() {
      this.request({
        url: '/standard_logistics/all',
        success: data => {
          this.logisticsCompany = Array.from(data, item => {
            return {
              name: item.logistics_name,
              value: item.id
            };
          });
        }
      });
    },
    //搜索
    searchHandle(data) {
      data.stationed_type = 1;
      this.searchDate = data;
      this.$refs.table.load({
        url: '/order/retail/list',
        data
      });
      this.searchParams = data || {};
    },
    //关闭订单（弹框）
    closeHandle(stop, data) {
      if (!stop) {
        this.orderNumber = data.order_number;
        this.cancel_reason = '';
        this.$refs.closeDia.open();
      } else {
        stop();
        if (!this.cancel_reason.trim()) {
          this.$message({
            text: '请填写关闭订单原因'
          });
          return;
        }
        this.closeSubmitForm();
        this.$refs.closeDia.close();
        this.$bus.$emit('order.update', {});

      }
    },
    //关闭订单（提交数据）
    closeSubmitForm() {
      this.request({
        url: '/order/cancel',
        data: {
          order_number: this.orderNumber,
          cancel_reason: this.cancel_reason.trim()
        },
        loading: true,
        success: () => {
          this.$message({
            icon: 'success',
            text: '申请取消订单成功'
          });
          this.$refs.table.update();
        }
      });
    },
    //订单下载
    downOrder(d, type) {
      this.request({
        url: '/order/getdownloadurl',
        data: {
          order_number: d.order_number,
          type: type
        },
        loading: true,
        success: data => {
          window.open(data);
        }
      });
    },
    //（异步）批量导出订单
    exportData() {
      var data = this.searchDate;
      data.job_id = 34;
      data.order_numbers = Array.from(this.$refs.table.getRow('selected'), item => item.data.order_number);
      this.request({
        url: '/export_job/add',
        data: data,
        loading: true,
        success: data => {
          this.$message({
            text: '订单导出任务提交成功，请稍后前往任务中心查看'
          });
        }
      });
    },
    //单个开票完成
    onInvoiceFinish(data) {
      var text_msg = `确定要对订单【<font style="font-size:15px;color:red;">${data.order_number}</font>】执行开票完成操作吗？`;
      this.realityMoney = (parseFloat(data.payment_money) || 0).toFixed(2);
      this.is_bath = 0;
      this.openInvoiceFinish(text_msg, [data.id]);
    },
    //批量开票完成
    batchInvoiceFinish() {
      this.is_bath = 1;
      this.realityMoney = null;
      let selectDatas = this.$refs.table.getRow(item => item.data.checked);
      var is_flag = true;
      if (!selectDatas.length) {
        stop();
        this.$message({
          text: '请选择需要执行开票完成的订单'
        });
        return;
      }

      selectDatas.forEach(item => {
        if (item.data.order_state != 5 || item.data.invoice_count <= 0 || item.data.invoice_state == 2 || item.data.check_state == 1) {
          is_flag = false;
        }
      });

      if (!is_flag) {
        this.$message({
          icon: 'fail',  // 图标（success：成功，fail：失败）
          text: '选择的订单中存在不符合开票条件的订单！'
        });
        return;
      }
      var order_ids = Array.from(selectDatas, item => item.data.id);
      var text_msg = `确定要对已选的【<font style="font-size:15px;color:red;">${selectDatas.length}笔</font>】订单执行开票完成操作吗？`;
      this.openInvoiceFinish(text_msg, order_ids);

    },
    //开票完成弹框
    openInvoiceFinish(text_msg, order_ids) {
      this.text_msg = text_msg;
      this.order_ids = order_ids;
      this.invoiceDate = new Date().format('yyyy-MM-dd hh:mm:ss');
      this.invoice_file_type = 1;
      this.invoice_file = '';
      this.$refs.invoiceConf.open();
    },
    //提交开票完成信息
    submitInvoiceFinish(stop) {
      stop();
      if (!this.invoiceDate) {
        this.$message({
          text: '请选择开票时间'
        });
        return;
      }
      if (this.is_bath == 0) {
        if (!this.realityMoney) {
          this.$message({
            text: '请输入实收金额'
          });
          return;
        }
        if (!this.invoice_file_type) {
          this.$message({
            text: '请选择开票凭证'
          });
          return;
        }
        if (!this.invoice_file) {
          if (this.invoice_file_type == 1) {
            this.$message({
              text: '请上传附件'
            });
            return;
          }
          if (this.invoice_file_type == 2) {
            this.$message({
              text: '请输入链接'
            });
            return;
          }
        } else if (this.invoice_file_type == 2) {
          if (this.invoice_file.indexOf('http://') !== 0 && this.invoice_file.indexOf('https://') !== 0) {
            this.$message({
              text: '请输入以http://或https://开头的完整链接'
            });
            return;
          }
        }
      }
      this.request({
        url: '/order/invoice_finish',
        data: {
          order_ids: this.order_ids,
          invoice_date: this.invoiceDate,
          reality_money: this.realityMoney,
          is_bath: this.is_bath,
          invoice_file_type: this.invoice_file_type,
          invoice_file: this.invoice_file
        },
        loading: true,
        success: data => {
          this.$message({
            icon: 'success',
            text: '执行开票完成操作成功'
          });
          this.$refs.table.update();
          this.$refs.invoiceConf.close();
          this.$refs.invoiceConfForm.clear();
        }
      });
    },

    //选择商家
    selectStationed(data) {
      this.$refs.searchForm.set({
        stationed_id: data[0].id,
        company_name: data[0].company_name
      });
    },

    //修改发货物流（弹框）
    editLogisticsCompany(val) {
      this.$refs.editLogisticsCompanyForm.clear();
      this.$refs.editLogisticsCompanyForm.set(val);
      this.$refs.editLogisticsCompanyDia.open();
    },
    //编辑运单号响应事件
    editLogisticsCompanyHandle(stop) {
      stop();
      this.$refs.editLogisticsCompanyForm.submit({
        url: '/order/edit_logistics_company',
        rule: {
          logistics_id: '请选择发货物流信息',
          logistics_number: [{
            type: 'empty',
            skip: (d) => {
              return d.logistics_id < 0;
            },
            word: '请填写运单号码信息'
          }]
        },
        dataFormatter: data => {
          return data;
        },
        success: (data, res) => {
          this.$message({
            text: '修改发货物流成功！'
          });
          this.$refs.table.update();
          this.$refs.editLogisticsCompanyDia.close();
        }
      });
    },

    /**同步导出数据*/
    syncExport() {
        let orderIds = this.$refs.table.getRow(item => item.data.checked).map(item => item.data.id);
        this.request({
        url: '/export/url',
        data: Object.assign({
          ids: orderIds,
          work_type: this.workType //业务类型
        }, this.searchParams),
        success: data => {
          this.download({
            fileName: data.filename,
            url: data.url,
            loading: {
              message: '数据文件生成中...'
            }
          })
        }
      });
    }
  }
}
</script>
<style lang="stylus" scoped>
.order {
  &-verify {
    padding: 20px;

    textarea {
      box-sizing: border-box;
      width: 100%;
      height: 120px;
      border: none;
      padding: 10px 14px;
      line-height: 20px;
      background: #FAFAFA;
      resize: none;
    }
  }
}

.order {
  border: 1px solid #eee;
  margin: 16px 0;

  &-head {
    border-bottom: 1px solid #eee;
    padding: 6px 8px;
    line-height: 22px;
    font-size: 12px;
    background: #F8F8F8;

    .number {
      margin-left: 10px;
      color: #333;
    }

    .tag {
      align-self: center;
      border-radius: 2px;
      padding: 0 5px;
      margin-left: 6px;
      line-height: 18px;
      color: #fff;
    }

    .info {
      position: relative;
      padding-left: 10px;
      white-space: nowrap;
      color: #999;

      &:nth-child(n+2) {
        &:after {
          content: '';
          position: absolute;
          left: 0;
          top: 3px;
          height: 16px;
          border-left: 1px solid #999;
        }

        margin-left: 10px;
      }
    }
  }

  &-product {
    flex-grow: 790;
    flex-basis: 790px;

    .sku {
      &:nth-child(n+2) {
        border-top: 1px solid #eee;
      }

      &-info {
        flex-grow: 400;
        flex-basis: 400px;
        box-sizing: border-box;
        padding: 10px 0 10px 14px;
      }

      &-image {
        width: 80px;
        height: 80px;
        margin-right: 24px;
      }

      &-name {
        font-size: 12px;
        color: #666;
      }

      &-sku {
        margin-top: 10px;
        font-size: 12px;
      }

      &-price,
      &-code,
      &-count {
        flex-grow: 130;
        flex-basis: 130px;
        font-size: 13px;
        text-align: center;
        color: #333;
      }
    }
  }

  &-sum,
  &-state,
  &-handle {
    flex-grow: 170;
    flex-basis: 170px;
    box-sizing: border-box;
    border-left: 1px solid #eee;
  }

  &-sum {
    line-height: 20px;
    font-size: 12px;
    text-align: center;
    color: #333;

    span {
      color: #888;
    }
  }

  &-state {
    line-height: 20px;
    font-size: 12px;

    a {
      color: #0060EF;
    }
  }

  &-handle {
    padding: 10px 0;

    .c-button {
      width: 6em;

      &:nth-child(n+2) {
        margin-top: 8px;
      }
    }
  }
}

.invoice {
  padding: 5px 10px;
  box-sizing: border-box;

  p {
    font-weight: bold;
    margin-bottom: 30px;
    font-size: 15px;
  }
}
</style>